/**
 * Local type and utility replacements for the deprecated react-places-autocomplete library.
 * Uses google.maps.places.AutocompleteSuggestion (new Places API) instead of AutocompleteService.
 */

export interface Suggestion {
  id: string;
  active: boolean;
  index: number;
  description: string;
  placeId: string;
  formattedSuggestion: {
    mainText: string;
    secondaryText: string;
  };
  matchedSubstrings: ReadonlyArray<{ length: number; offset: number }>;
  terms: ReadonlyArray<{ offset: number; value: string }>;
  types: ReadonlyArray<string>;
}

export async function geocodeByAddress(
  address: string
): Promise<google.maps.GeocoderResult[]> {
  const geocoder = new google.maps.Geocoder();
  const response = await geocoder.geocode({ address });
  return response.results;
}
